import { Button, ColumnHeader, IColumnHeader, Icon, SearchBolder, Select, Switch, Table, TableRow } from '@aon/aon-tws-common-ui';
import React from 'react';
import { useAppDispatch } from '../../../../appStore';
import { ISurveyQuestionEditModel, SeverityType } from '../../../../models';
import { toggleResponseIsRequired } from '../../../../store/SurveyQuestionsAdminSlice';
import { assertNonNullable } from '../../../../utilities/assertions';
import { WarningBox } from '../../../common/warnings';

interface IQFollowUpQuestionsTableRowProps {
	errors?: string[];
	isParentRequired: boolean;
	question: ISurveyQuestionEditModel;
	searchText: string;
	warnings?: string[];
	editTranslations: (surveyQuestionId: number) => void;
}

export const FollowUpQuestionsTableRow = ({
	errors,
	isParentRequired,
	question,
	searchText,
	warnings,
	editTranslations,
}: IQFollowUpQuestionsTableRowProps) => {
	const dispatch = useAppDispatch();
	const selectedDimensionsDisplayText: string = String(question.responseOptions ? question.responseOptions.length : 0) + ' Selected';
	const columns = [
		{
			label: 'Follow Up Question & Dimension',
			field: 'followUpQuestionText',
			sortAscByDefault: false,
			isSortable: false,
			tooltipContent: undefined,
		},
		{
			label: 'Response Options',
			field: 'followUpResponseOptions',
			sortAscByDefault: false,
			isSortable: false,
			tooltipContent: undefined,
		},
		{
			label: 'Response Required',
			field: 'followUpResponseRequired',
			sortAscByDefault: false,
			isSortable: false,
			tooltipContent: undefined,
		},
		{ label: 'Max', field: 'selectionLimit', sortAscByDefault: false, isSortable: false, tooltipContent: undefined },
		{
			label: 'Translations',
			field: 'followUpQuestionTranslations',
			sortAscByDefault: false,
			isSortable: false,
			tooltipContent: undefined,
		},
	];
	return (
		<Table responsive={true} lastalign={columns.length === 5 ? 'right' : undefined}>
			<ColumnHeader columns={columns} />
			<tbody>
				<TableRow key={question.surveyQuestionId}>
					{columns.map((column: IColumnHeader) => (
						<td key={`${question.surveyQuestionId}-${column.field}`}>
							{{
								followUpResponseOptions: <Select displayText={selectedDimensionsDisplayText} disabled={true} />,
								followUpResponseRequired: (
									<Switch
										text={<span className='sr-only'>Response Required for Question {question.code}</span>}
										checked={isParentRequired ? question.isRequired : false}
										disabled={!isParentRequired}
										onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
											dispatch(
												toggleResponseIsRequired({
													surveyQuestionId: question.surveyQuestionId,
													isRequired: event.target.checked,
												}),
											)
										}
									/>
								),
								followUpQuestionText: (
									<>
										<SearchBolder searchText={searchText} text={question.text} />
										{errors !== undefined && errors.length > 0 && <WarningBox severity={SeverityType.Error} messages={errors} />}
										{warnings !== undefined && warnings.length > 0 && <WarningBox severity={SeverityType.Warning} messages={warnings} />}
									</>
								),
								followUpQuestionTranslations: (
									<Button
										id={`edit-translation-btn-${question.surveyQuestionId}`}
										color='transparent'
										onClick={() => {
											assertNonNullable(question.surveyQuestionId);
											editTranslations(question.surveyQuestionId);
										}}
										size='md'
										disabled={false}
										aria-label={`Edit Translations for Question ${question.code}`}
									>
										<Icon name='edit' />
									</Button>
								),
								selectionLimit: <Select displayText={String(question.selectionLimit ? question.selectionLimit : 1)} disabled={true} />,
							}[column.field] || <SearchBolder searchText={searchText} text={question[column.field]} />}
						</td>
					))}
				</TableRow>
			</tbody>
		</Table>
	);
};
